import { render, staticRenderFns } from "./DowntimeReport.vue?vue&type=template&id=28a1cb01&"
import script from "./DowntimeReport.vue?vue&type=script&lang=js&"
export * from "./DowntimeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports